var _excluded = ["type", "text", "onClose", "closeButtonLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import Box from "../Box";
import Button from "../Button";
import Icon from "../Icon";
import Container, { StyledBannerIcon } from "./styles";
var getBannerIconName = function getBannerIconName(type) {
  switch (type) {
    case 'success':
      return 'circle-check-no-fill';
    case 'error':
      return 'triangle';
    case 'warning':
      return 'triangle';
    case 'opportunity':
      return 'sparkles';
    case 'info':
    default:
      return 'info-white';
  }
};
var getBannerIconColor = function getBannerIconColor(type) {
  switch (type) {
    case 'success':
      return 'icon.success';
    case 'error':
      return 'icon.error';
    case 'warning':
      return 'icon.warning';
    case 'opportunity':
      return 'icon.opportunity';
    case 'info':
    default:
      return 'icon.info';
  }
};

/** TODO: change to 'info' type by default in future version */
var Banner = function Banner(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    text = _ref.text,
    onClose = _ref.onClose,
    _ref$closeButtonLabel = _ref.closeButtonLabel,
    closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'Close' : _ref$closeButtonLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Container, _extends({
    type: type,
    "data-qa-alert": "",
    "data-qa-alert-type": type,
    "data-qa-alert-text": text
  }, rest), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    width: 1
  }, /*#__PURE__*/React.createElement(StyledBannerIcon, {
    name: getBannerIconName(type),
    color: getBannerIconColor(type),
    className: "Icon",
    fixedWidth: true,
    mt: "3px",
    mr: 400
  }), text, onClose && /*#__PURE__*/React.createElement(Box, {
    ml: "auto",
    pl: 400,
    alignSelf: "flex-start"
  }, /*#__PURE__*/React.createElement(Button, {
    p: 0,
    onClick: onClose,
    ariaLabel: closeButtonLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x",
    "aria-hidden": true
  })))));
};
export default Banner;